export default __webpack_public_path__ + "img/no-image-post.58cb04d7.gif";